import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import React from "react";
import NocHome from "../pages/noc/NocHome.tsx";
import Home from "../pages/home/Home.tsx";

export const PrivateRoutes = ({screen}) => {
  const isNoc = localStorage.getItem("noc") === "true";
  return (
    <Routes>
      <Route path="/" element={isNoc ?  <Navigate to="/noc" replace /> : <Navigate to="/state" replace />} />
      <Route path="/state" element={<Home />} />
      <Route path="/country" element={<Home />} />
      <Route path="/noc" element={<NocHome />} />
      <Route path="*" element={isNoc ?  <Navigate to="/noc" replace />: <Navigate to="/state" replace />} />
    </Routes>
  );
};
